import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdAddPhotoAlternate,
  MdDelete,
  MdEdit,
  MdSupportAgent,
} from "react-icons/md";
import userPhoto from "./../../images/user.png";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { ExclamationCircleFilled } from "@ant-design/icons";
import api from "../../services/api";
import {
  Container,
  Cards,
  Card,
  Title,
  ViewInput,
  Table,
  Scroll,
} from "../../GlobalStyles";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { Button, Modal, Input, Pagination } from "antd";
import { useAuth } from "../../hooks/AuthContext";

const { confirm } = Modal;

const { TextArea } = Input;

const Secretarias = () => {
  const { user } = useAuth();

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [usersTotal, setUsersTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState("");
  const [observation, setObservation] = useState("");
  const [email, setEmail] = useState("");
  const [page, setPage] = useState(0);
  const [password, setPassword] = useState("");
  const [photo, setPhoto] = useState("");
  const [id, setId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  useEffect(() => {
    if (user.role != "ADMIN") {
      navigate("/");
    }
    loadUsers();
    window.scrollTo(0, 0);
  }, [page]);

  async function loadUsers() {
    await api
      .get(`/users?page=${page}&type=SECRETARY`)
      .then((response) => {
        setUsers(response.data.users);
        setUsersTotal(response.data.usersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  async function createUser() {
    setIsLoadingModal(true);
    if (!name || !email || !password) {
      toast.warning("Nome, Email e Senha são obrigatórios");
    } else {
      const data = new FormData();
      data.append("name", name);
      data.append("email", email);
      data.append("password", password);
      data.append("observation", observation);
      data.append("role", "SECRETARY");
      if (photo.name) {
        data.append("file", photo, photo.name);
      }
      await api
        .post(`/user`, data)
        .then((response) => {
          toast.success("Secretária criada com sucesso");
          setIsOpen(false);
          loadUsers();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function editUser() {
    setIsLoadingModal(true);
    if (!name || !email) {
      toast.warning("Nome e email são obrigatórios");
    } else {
      const data = new FormData();
      data.append("name", name);
      data.append("email", email);
      data.append("password", password);
      data.append("observation", observation);
      data.append("role", "SECRETARY");
      if (photo.name) {
        data.append("file", photo, photo.name);
      }
      await api
        .put(`/user/${id}`, data)
        .then((response) => {
          toast.success("Secretária editada com sucesso");
          setIsOpen(false);
          loadUsers();
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        });
    }
    setIsLoadingModal(false);
  }

  async function deleteUser(user) {
    await api
      .delete(`/user/${user.id}`)
      .then((response) => {
        toast.success("Secretária deletada com sucesso");
        loadUsers();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <Title>
        <h2>Secretárias</h2>
        <div>
          <Button
            type="primary"
            onClick={() => {
              setId("");
              setName("");
              setEmail("");
              setPassword("");
              setPhoto("");
              setObservation("");
              setIsOpen(true);
            }}
          >
            <MdAdd size="20" color="#fff" />
            <span>Nova Secretária</span>
          </Button>
        </div>
      </Title>
      <Cards>
        <Card>
          <div className="icon">
            <MdSupportAgent color="#848484" size={32} />
          </div>
          <div className="number">
            <CountUp duration={1} end={usersTotal} />
            <p>Total</p>
          </div>
        </Card>
      </Cards>

      {!isLoading && (
        <>
          {users.length ? (
            <>
              <Scroll>
                <Table>
                  <thead>
                    <tr>
                      <td style={{ width: 50 }}></td>
                      <td>Nome</td>
                      <td>Email</td>
                      <td style={{ width: 80 }}></td>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user) => (
                      <tr key={user.id}>
                        <td style={{ width: 40 }}>
                          <img
                            style={{ width: 30, height: 30, borderRadius: 2 }}
                            src={user.photo_url || userPhoto}
                          />
                        </td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td style={{ width: 120 }}>
                          <div
                            style={{
                              display: "flex",
                              cursor: "pointer",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <MdEdit
                              onClick={() => {
                                setId(user.id);
                                setName(user.name);
                                setObservation(user.observation);
                                setEmail(user.email);
                                setPassword("");
                                setPhoto({ photo_url: user.photo_url });
                                setIsOpen(true);
                              }}
                              style={{ cursor: "pointer", marginLeft: 10 }}
                              size={22}
                              color={"#001B22"}
                            />
                            <MdDelete
                              onClick={() => {
                                confirm({
                                  title: "Deseja excluir o Secretária?",
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após essa ação, o Secretária ${user.name} será excluido.`,
                                  onOk() {
                                    deleteUser(user);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{ cursor: "pointer", marginLeft: 6 }}
                              size={22}
                              color={"#001B22"}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Scroll>
              <center style={{ marginTop: 15 }}>
                <Pagination
                  showSizeChanger={false}
                  defaultCurrent={page + 1}
                  onChange={(page) => {
                    setPage(page - 1);
                  }}
                  total={usersTotal}
                  pageSize={30}
                  showTotal={(total) => `${total} secretárias`}
                />
              </center>
            </>
          ) : (
            <div className="error">
              <p>Nenhuma secretária encontrada</p>
            </div>
          )}
        </>
      )}

      {isLoading && <Loader />}
      <Modal
        title={id ? "Editar Secretária" : "Nova Secretária"}
        width={500}
        confirmLoading={isLoadingModal}
        open={isOpen}
        okText={id ? "EDITAR SECRETÁRIA" : "CADASTRAR SECRETÁRIA"}
        cancelText="FECHAR"
        onOk={() => {
          if (id) {
            editUser();
          } else {
            createUser();
          }
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginBottom: 25,
          }}
        >
          <div
            style={{
              marginTop: 0,
              display: "flex",
              width: "100%",
              alignItems: "end",
              height: 120,
              borderRadius: 10,
              marginBottom: 25,
              marginBottom: 20,
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: 120,
                marginLeft: 50,
                height: 120,
                borderRadius: 10,
                background: "#fff",
              }}
              src={photo.photo_url ? photo.photo_url : userPhoto}
            />
            <button
              style={{
                width: 50,
                height: 50,
                border: "none",
                background: "transparent",
              }}
            >
              <label
                for="avatar"
                style={{
                  display: "flex",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <MdAddPhotoAlternate color="#001B22" size={25} />
                <input
                  id="avatar"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/png,image/jpeg"
                  onChange={(file) => {
                    let photo = file.target.files[0];
                    photo.photo_url = URL.createObjectURL(file.target.files[0]);
                    setPhoto(photo);
                  }}
                />
              </label>
            </button>
          </div>
          <ViewInput>
            <p>Nome*</p>
            <Input
              placeholder="nome"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Email*</p>
            <Input
              placeholder="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>{id ? "Nova Senha" : "Senha"}*</p>
            <Input
              placeholder="senha"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Observação</p>
            <TextArea
              placeholder="deixe uma observação"
              autoSize={{ maxRows: 5 }}
              style={{
                minWidth: "100%",
                display: "flex",
                alignItems: "center",
                paddingTop: 7,
              }}
              value={observation}
              onChange={(event) => setObservation(event.target.value)}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
};

export default Secretarias;
